import store from "~/store";

export default async function isAuthenticated()
{
  // console.log("called isAuthenticated middleware");
  if (!store.getters["auth/token"])
  {
    return { name: "login" };
  } else
  {
    await store.dispatch("auth/fetchUser"); //todo always fresh data?
  }
}

export function checkUserRole(role)
{
  return async function (props)
  {
    //console.log("called check role middleware");

    if (!store.getters["auth/token"])
    {
      return { name: "login" };
    } else
    {
      try
      {
        await store.dispatch("auth/fetchUser");

        const isExists = await store.dispatch("auth/checkRoles", roles[role]);

        // console.log("check Role", role, roles[role], isExists);

        if (!isExists)
        {
          return { name: "booking.add" };
        }
      } catch (error)
      {
        console.error("Error in checkUserRole middleware:", error);
        return error;
      }
    }
  };
}
export async function isSugarAuthorized()
{

  console.log("called isSugarAuthorized middleware");

  if (!store.getters["auth/token"])
  {
    return { name: "login" };
  } else
  {
    try
    {
      await store.dispatch("auth/fetchUser");

      const isSugarAuthorized = await store.dispatch("auth/checkSugar");
      const isProjectManager = await store.dispatch("auth/checkRoles", roles["projectManager"]);

      // console.log("check Role", role, roles[role], isExists);

      if (!isSugarAuthorized && !isProjectManager)
      {
        return { name: "booking.add" };
      }
    } catch (error)
    {
      console.error("Error in isSugarAuthorized middleware:", error);
      return error;
    }
  }

}

// Authorized roles
const roles = {
  guestManager: [],
  superadmin: ["SUPERADMIN"],
  admin: ["SUPERADMIN", "ADMIN", "HM"],
  groupManager: ["SUPERADMIN", "ADMIN", "HM", "PLANNER"],
  plannerManager: ["SUPERADMIN", "ADMIN", "HM", "PLANNER"],
  projectManager: ["SUPERADMIN", "ADMIN", "HM", "PM", "TM"],
  teamManager: ["SUPERADMIN", "ADMIN", "HM", "TM", "PLANNER"],
  user: ["SUPERADMIN", "ADMIN", "HM", "PM", "TM", "PLANNER", "USER"],
};
